import { render, staticRenderFns } from "./Livestream.vue?vue&type=template&id=5476def2&lang=pug&"
import script from "./Livestream.vue?vue&type=script&lang=js&"
export * from "./Livestream.vue?vue&type=script&lang=js&"
import style0 from "./Livestream.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports